
<template>
  <CreateOrderTransferPromo office-type="stockist_center" :index-route="{ name: 'penjualan.kirim-barang-promo.ke-sc' }" />
</template>

<script>
import CreateOrderTransferPromo from '../../../../../components/order/create-order-transfer-promo.vue';

export default {
  components: {
    CreateOrderTransferPromo
  }
}
</script>